export default async function createPreview(
	fontFile: File,
	text: string
): Promise<File | null> {
	const fontName = 'CustomFont'
	if (!fontFile) return null

	const fontUrl = URL.createObjectURL(fontFile)

	// load font
	const font = new FontFace(fontName, `url(${fontUrl})`)
	await font.load()
	document.fonts.add(font)

	const canvas = document.createElement('canvas')
	const ctx = canvas.getContext('2d')!

	const fontSize = 50


	ctx.font = `${fontSize}px ${fontName}`
	const metrics = ctx.measureText(text)
	const textWidth = Math.ceil(metrics.width)+ 10
	const textHeight = Math.ceil(
		metrics.actualBoundingBoxAscent +
		metrics.actualBoundingBoxDescent
	) + 20
	canvas.width = textWidth
	canvas.height = textHeight

	// redraw after resize
	ctx.font = `${fontSize}px ${fontName}`
	ctx.fillStyle = '#000'
	ctx.textBaseline = 'middle'
	ctx.textAlign = 'left'

	ctx.fillText(text, 5, textHeight / 2)

	const blob: Blob = await new Promise(resolve =>
		canvas.toBlob(b => resolve(b!), 'image/png')
	)

	URL.revokeObjectURL(fontUrl)

	return new File([blob], 'preview.png', { type: 'image/png' })
}